import { compose } from "recompose";

import { protectedComponentHoc } from "../../components/ProtectedComponent";
import { TranslationsComponent } from "./component";

export const Translations = compose(protectedComponentHoc)(TranslationsComponent);
